const INITIAL_STATE = { process_geracao_carne: 'N', processo_geracao_pdf_carne:'N' }

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'CARNE_AUTOMATICO_PROCESS_GERACAO':
            return { ...state, process_geracao_carne: action === null ? '' : action.payload.data.valor_config }

        case 'UNIDADE_ATIVAS_FETCHED':
            return { ...state, unidades_ativas: action.payload.data }

        case 'CARNE_AUTOMATICO_PROCESS_GERACAO_PDF':
            return { ...state, processo_geracao_pdf_carne: action === null ? 'N' : action.payload.data.valor_config === '' ? 'N' : action.payload.data.valor_config }
        default: return state

    }
}


// WEBPACK FOOTER //
// ./src/rotinaautomatica/rotina_automaticaReducer.js